import { Injectable } from '@angular/core';
import { Trip } from './trip.model';
import LatLngBounds = google.maps.LatLngBounds;
import Padding = google.maps.Padding;

@Injectable()
export class MapManagementService {
  defaultLat  = 47.988212705125434;
  defaultLng  = 13.40030886232853;
  defaultZoom = 5;

  mapFitPadding: Padding = {
    top: 80,
    bottom: 80,
    left: 50,
    right: 50
  }

  centerView(trip: Trip, map, singleTrip) {
    if (trip && trip.timelineParamsInitialized && map) {
      const bounds: LatLngBounds = new window['google'].maps.LatLngBounds();
      if (!trip) {
        bounds.extend(new window['google'].maps.LatLng(this.defaultLat, this.defaultLng));
        bounds.extend(new window['google'].maps.LatLng(this.defaultLat + 5, this.defaultLng + 5));
        bounds.extend(new window['google'].maps.LatLng(this.defaultLat - 5, this.defaultLng - 5));
      } else if (singleTrip) {
        bounds.extend(new window['google'].maps.LatLng(trip.destPosition.lat, trip.destPosition.lng));
        if (trip.latestPing) {
          bounds.extend(new window['google'].maps.LatLng(trip.latestPing.latitude, trip.latestPing.longitude));
        }
        if (trip.achievedPaths[0]) {
          bounds.extend(new window['google'].maps.LatLng(trip.destPosition.lat, trip.destPosition.lng));
        }
        for (const p of trip.forecastPath) {
          bounds.extend(new window['google'].maps.LatLng(p.lat, p.lng));
        }
      } else {
        bounds.extend(new window['google'].maps.LatLng(trip.originPosition.lat, trip.originPosition.lng));
        bounds.extend(new window['google'].maps.LatLng(trip.destPosition.lat, trip.destPosition.lng));
        if (trip.achievedPaths[0]) {
          for (const path of trip.achievedPaths[0].paths) {
            for (const ping of path.pings) {
              bounds.extend(new window['google'].maps.LatLng(ping.latitude, ping.longitude));
            }
          }
        }
      }
      map.fitBounds(bounds, this.mapFitPadding);
    }
  }
}
